import React from 'react';
import {Field, reduxForm} from 'redux-form';
import label from '../../utils/lngEn';
import FormField from '../common/FormField';
import Validate from '../common/formValidate';
import DropdownList from 'react-widgets/lib/DropdownList';

const renderDropdownList = ({input, meta: {touched, error}, ...rest}) => (
  <div>
    <DropdownList {...input} {...rest}/>
    <div>
      {touched && (error && <span className="text-danger">{error}</span>)}
    </div>
  </div>
)

const GroupForm = (props) => {
  const {handleSubmit, submitting, assignment_complete} = props;
  return (
    <form onSubmit={handleSubmit} className="group-form">
      <Field
        name="name"
        type="text"
        component={FormField}
        label={label.groupName}
        validate={[Validate.Required]}
        description={label.groupNameDesc}/>
      <Field
        name="description"
        type="text"
        component={FormField}
        label={label.groupDescription}
        validate={[Validate.StringRange150]}
        description={label.groupDescriptionDesc}/>
      { !assignment_complete && (
        <div className="form-group">
          <Field
            name="budget_adjustment"
            valueField="value"
            textField="option"
            data={[
              {option: 'No Change', value: 0},
              {option: '+10 (small boost)', value: 10},
              {option: '+50 (large boost)', value: 50},
              {option: '+250 (huge boost)', value: 250}
            ]}
            component={renderDropdownList}/>
          <span className="input-description">{label.groupBudgetAdjustmentDesc}</span>
        </div>
      )}

      <button className="btn btn-primary pull-right" type="submit" disabled={submitting}>Save</button>
    </form>
  )
}

export default reduxForm({
  form: 'GroupForm'
})(GroupForm);



// WEBPACK FOOTER //
// ./src/components/groups/GroupForm.js